import Icon from './icon';
export default {
  Icon,
  title: 'Segmentation',
  hotkey: 'b'
};